import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { profilePhotoSrc } from "../api/cabinet";
import logo from "../assets/logo.png";
import "./Header.css";

/**
 * Шапка сайта (sticky). Навигация + auth-блок.
 * Гость — кнопки «Войти» / «Регистрация».
 * Залогинен — username, баланс алмазов, кнопка «Выйти».
 */
export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  // Аватарка: бэк отдаёт в photo ИМЯ ФАЙЛА, а не URL — полный путь строит
  // profilePhotoSrc (/api-user/assets/profile/...). Раньше имя шло в src
  // напрямую → браузер получал SPA-HTML и рисовал сломанную картинку.
  // Если файл не загрузился — падаем на букву-инициал.
  const [avatarBroken, setAvatarBroken] = useState(false);
  useEffect(() => { setAvatarBroken(false); }, [user?.photo]);
  const avatarSrc = avatarBroken ? null : profilePhotoSrc(user?.photo);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate("/");
  };

  return (
    <header className="rb-header">
      <div className="rb-container rb-header__inner">
        <Link to="/" className="rb-header__brand" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Рублокс" className="rb-header__logo" />
          <span className="rb-header__name">Рублокс</span>
        </Link>

        <button
          className="rb-header__burger"
          aria-label="Меню"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`rb-header__nav ${menuOpen ? "is-open" : ""}`}>
          <NavLink
            to="/"
            end
            className="rb-header__link"
            onClick={() => setMenuOpen(false)}
          >
            Главная
          </NavLink>
          <NavLink
            to="/download"
            className="rb-header__link"
            onClick={() => setMenuOpen(false)}
          >
            Скачать
          </NavLink>
          <a
            href="/#about"
            className="rb-header__link"
            onClick={() => setMenuOpen(false)}
          >
            О платформе
          </a>

          {isAuthenticated ? (
            <div className="rb-header__auth rb-header__auth--user">
              {/* профиль ведёт в кабинет — клик открывает /app */}
              <Link
                to="/app"
                className="rb-header__profile"
                onClick={() => setMenuOpen(false)}
                title="Открыть кабинет"
              >
                {avatarSrc ? (
                  <img
                    className="rb-header__avatar"
                    src={avatarSrc}
                    alt={user.username || "Профиль"}
                    onError={() => setAvatarBroken(true)}
                  />
                ) : (
                  <span className="rb-header__avatar" aria-hidden>
                    {(user?.username || "?").charAt(0).toUpperCase()}
                  </span>
                )}
                <span className="rb-header__username">
                  {user?.username || "Профиль"}
                </span>
              </Link>
              <Link
                to="/app"
                className="rb-btn rb-btn--primary"
                onClick={() => setMenuOpen(false)}
              >
                Кабинет
              </Link>
              <button
                className="rb-btn rb-btn--ghost"
                onClick={handleLogout}
              >
                Выйти
              </button>
            </div>
          ) : (
            <div className="rb-header__auth">
              <Link
                to="/login"
                className="rb-btn rb-btn--ghost"
                onClick={() => setMenuOpen(false)}
              >
                Войти
              </Link>
              <Link
                to="/signup"
                className="rb-btn rb-btn--primary"
                onClick={() => setMenuOpen(false)}
              >
                Регистрация
              </Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
